import { render, staticRenderFns } from "./form-receipt-vin.vue?vue&type=template&id=4ffd8fbc"
import script from "./form-receipt-vin.vue?vue&type=script&lang=js"
export * from "./form-receipt-vin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogItemLargeMobileForm: require('/var/www/components/catalog/catalog-item/catalog-item-large-mobile-form.vue').default,InputsInput: require('/var/www/components/inputs/input.vue').default,CheckboxGroup: require('/var/www/components/Checkbox/group.vue').default,ButtonTypical: require('/var/www/components/button/button-typical.vue').default})
